import { useEffect, useState } from "react"
import { getColorById, postColor, patchColor } from "../../services/ColoresServices"
import { ColoresFormContext } from "./ColoresContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const ColoresFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getColorByIdData(id)
    }, [])

    const getColorByIdData = async (id) => {
        let res = await getColorById(id)
        
        if (res) setReport(res)
    }

    const postColorData = async (body) => {
        const res = await postColor(body)
        
        if (res) navigate("/colores");
    }

    const patchColorData = async (id, body) => {
        const res = await patchColor(id, body)

        if (res) navigate("/colores");
    }


    return <ColoresFormContext.Provider value={{
        report,
        postColorData,
        patchColorData,
    }} >
        {children}
    </ColoresFormContext.Provider>
}